import * as Sentry from "@sentry/react";

export function logError(error: unknown, context?: Record<string, unknown>) {
  console.error(error, context);
  Sentry.captureException(error, context ? { extra: context } : undefined);
}
